import axios from "axios";
import * as HeaderFiles from "../../header/header";

const apiGetAllAdminImagesEndpoint = HeaderFiles.apiGetAllAdminImagesEndpoint;

export const GET_ADMIN_IMAGES = "GET_ADMIN_IMAGES";

export const getAllAdminImagesAndStatus = () => async (dispatch) => {
    try {
        const response = await axios.get(apiGetAllAdminImagesEndpoint);
        let data = response.data;

        let admin_image_array = {};

        data.forEach(item => {
            admin_image_array[item._id] = {
                admin_image: item.admin_image,
                admin_status: item.admin_status
            };
        });

        dispatch({
            type: GET_ADMIN_IMAGES,
            payload: admin_image_array
        });

        return admin_image_array;

    } catch (error) {
        console.error("Error fetching admin images:", error);
        return {};
    }
};